import * as React from "react";
import * as moment from "moment";
import "./expirationReminderSent.scss";

var ExpirationReminderSent = function ExpirationReminderSent(props) {
  var expirationReminderSentAt = props.expirationReminderSentAt;

  if (!expirationReminderSentAt) {
    return null;
  }

  var formattedDate = moment(expirationReminderSentAt).format("DD-MM-YYYY HH:mm");
  return /*#__PURE__*/React.createElement("div", {
    className: "cntExpirationReminderSent"
  }, /*#__PURE__*/React.createElement("div", {
    className: "alert alert-success",
    role: "alert"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fa fa-check-circle"
  }), /*#__PURE__*/React.createElement("span", {
    className: "reminder-text"
  }, "Recordatorio enviado"), /*#__PURE__*/React.createElement("span", {
    className: "reminder-date"
  }, formattedDate)));
};

export default ExpirationReminderSent;